import React from 'react';
import { motion } from 'framer-motion';

const VehicleGallery = () => {
  const vehicles = [
    {
      type: 'Manual',
      description: 'Learn on our modern, dual-controlled manual car',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752423701287-woman-smiling-enjoying-driving-car.jpg'
    },
    {
      type: 'Automatic',
      description: 'Perfect for those who prefer automatic transmission',
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752423718479-happy-african-guy-adjusting-rear-view-mirror.jpg'
    }
  ];

  return (
    <section className="py-20 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4 transition-colors">
            Our Training Vehicles
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto transition-colors">
            Learn to drive in our modern, well-maintained vehicles equipped with dual controls for your safety.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {vehicles.map((vehicle, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="bg-gray-50 dark:bg-gray-800 rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-gray-700"
            >
              <div className="w-full h-64 overflow-hidden">
                <img
                  src={vehicle.image}
                  alt={`${vehicle.type} training vehicle interior`}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2 transition-colors">
                  {vehicle.type} Vehicle
                </h3>
                <p className="text-gray-600 dark:text-gray-300 transition-colors">
                  {vehicle.description}
                </p>
              </div>
              <div className="px-6 pb-6">
                <div className="flex flex-wrap gap-2">
                  <span className="bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-3 py-1 rounded-full text-sm font-medium transition-colors">
                    Dual Controls
                  </span>
                  <span className="bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-3 py-1 rounded-full text-sm font-medium transition-colors">
                    Modern
                  </span>
                  <span className="bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-3 py-1 rounded-full text-sm font-medium transition-colors">
                    Well-Maintained
                  </span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VehicleGallery;